var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "centered" }, [
    _c("div", { staticClass: "container mb-auto mt-auto" }, [
      _c("form", { staticClass: "form-signin" }, [
        _c("div", { staticClass: "card mx-auto card-auth border-0" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("router-link", { attrs: { to: "/" } }, [
                  _c("img", {
                    staticClass: "logo-h mb-3",
                    attrs: {
                      src: "/img/mpower_logo_text_nopad.png",
                      alt: "MPower Promo",
                    },
                  }),
                ]),
                _c("h3", { staticClass: "my-3" }, [_vm._v(_vm._s(_vm.title))]),
              ],
              1
            ),
            _c("span", {
              staticClass: "reauth-email",
              attrs: { id: "reauth-email" },
            }),
            _vm.err.length
              ? _c(
                  "div",
                  { staticClass: "alert alert-danger" },
                  _vm._l(_vm.err, function (error) {
                    return _c("div", {
                      key: error,
                      domProps: { innerHTML: _vm._s(error) },
                    })
                  }),
                  0
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("PasswordInput", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|passwordRules",
                      expression: "'required|passwordRules'",
                    },
                  ],
                  ref: "password",
                  attrs: {
                    label: "New Password",
                    name: "password",
                    autocomplete: "off",
                    showValidation: true,
                  },
                  model: {
                    value: _vm.newPasswordFirst,
                    callback: function ($$v) {
                      _vm.newPasswordFirst = $$v
                    },
                    expression: "newPasswordFirst",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("PasswordInput", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password",
                      expression: "'required|confirmed:password'",
                    },
                  ],
                  attrs: {
                    label: "Confirm New Password",
                    name: "confirm_password",
                    autocomplete: "off",
                    "data-vv-as": "Password Confirmation",
                    showValidation: false,
                  },
                  model: {
                    value: _vm.newPasswordSecond,
                    callback: function ($$v) {
                      _vm.newPasswordSecond = $$v
                    },
                    expression: "newPasswordSecond",
                  },
                }),
                _c("div", { staticClass: "invalid-feedback d-block" }, [
                  _vm._v(_vm._s(_vm.errors.first("confirm_password"))),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "card-body" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { disabled: _vm.errors.any() },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setNewPassword.apply(null, arguments)
                  },
                },
              },
              [
                _vm.loading
                  ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                  : _vm._e(),
                _vm._v(" Save Password\n          "),
              ]
            ),
            _c(
              "a",
              {
                staticClass: "btn btn-link",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "auth/forgot" })
                  },
                },
              },
              [_vm._v("Cancel")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }